import { render } from "./PayMyItems.vue?vue&type=template&id=48df3c96&scoped=true&ts=true"
import script from "./PayMyItems.vue?vue&type=script&lang=ts"
export * from "./PayMyItems.vue?vue&type=script&lang=ts"

import "./PayMyItems.vue?vue&type=style&index=0&id=48df3c96&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48df3c96"]])

export default __exports__